export default {
	'report-purchase-sell-stock-standing-book': {
		id: 'report-purchase-sell-stock-standing-book',
		label: '品项进销存台账查询',
		code: '0008_0003'
	}
}
